import React from 'react';
import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import { NormalText } from '../../Styles';
import TransferIcon from '@app/images/transfer.svg';
import ArrowsIcon from '@app/images/arrows.svg';
import config from '@app/config';
import { PingPongUSDFormDetails } from './PingPongUSDAfterForm';

export const NiumBarclaysAfterForm: InstructionFormDetails = {
  ...PingPongUSDFormDetails,
  paymentInstructionsLines: [
    {
      description: 'supplierValidation.afterRegister.beneficiaryName',
      value: 'nsKnox Technologies, Ltd.',
    },
    {
      description: 'supplierValidation.afterRegister.address',
      value: '135 Madison Ave, New York, NY 10016',
    },
    { description: 'supplierValidation.afterRegister.checkingAccount', value: '84799366' },
    { description: 'supplierValidation.afterRegister.swift', value: 'BARCGB22' },
    { description: 'supplierValidation.afterRegister.iban', value: 'GB35BARC20000084799366' },
  ],
  paymentInstructionsAddress: {
    description: 'supplierValidation.afterRegister.bankAndAddress',
    value: (
      <NormalText>
        Barclays Bank PLC,1 Churchill Place,
        <br />
        London E14 5HP
      </NormalText>
    ),
  },
  currencies: [],
  pleaseNote: {
    pleaseNoteItem: [
      'supplierValidation.afterRegister.transferMustBe',
      'supplierValidation.afterRegister.pingPongUSD.transferShouldBe',
      'supplierValidation.afterRegister.invoice',
    ],
    hideInvoice: true,
  },
  showWireTransferWarningBox: {
    achWireTransfer: false,
    swiftWireTransfer: false,
  },
  extraInstructions: [
    { icon: TransferIcon, text: 'supplierValidation.afterRegister.pingPongUSD.step1' },
    { icon: ArrowsIcon, text: 'supplierValidation.afterRegister.pingPongUSD.step2' },
  ],
  downloadLink: `${config.supplierValidationAttachmentsUrl}NiumBarclays/en/Nium-Barclays.pdf`,
};
